import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtnCloseComponent } from '../../button/btn-close/btn-close.component';
import { InAppNotificationsService, InAppNotificationsStore } from '@program-suite/data-common';;
import{ ButtonComponent } from '../../button/button.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'lib-notifications-modal',
  imports: [CommonModule, BtnCloseComponent, MatCheckboxModule, ButtonComponent],
  templateUrl: './notifications-modal.component.html',
  styleUrl: './notifications-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsModalComponent {
  notificationsStore = inject(InAppNotificationsStore);
  title = 'Notifications';
  // notifications =  this.notificationsStore.inAppNotifications() as any[]
  notifications =  [
    {
      "title": "Hey, you got some important stuff to do!",
      "message": "You have a new submission that needs your <b>attention.</b>",
      "age": "1 hour",
      "checked": false
    },
    {
      "title": "Hey, you got some more important stuff to do!",
      "message": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      "age": "06-03-1952",
      "checked": false
    }
  ]
  selectAllChecked = false;

  menuItems = [
    { name: 'Mark As Read', route: '', action: () => {} },
    { name: 'Mark As Unread', route: '', action: () => {} },
    { name: 'Archive', route: '', action: () => {} },
  ];

  constructor(
    private inAppNotificationsService: InAppNotificationsService,
    private cdr: ChangeDetectorRef,
  ) {}

  toggleAll(checked: boolean) {
    this.selectAllChecked = checked;
    this.notifications.forEach(notification => {
      notification.checked = checked;
    });
    this.cdr.markForCheck(); 
  }

  updateSelectAll() {
    this.selectAllChecked = this.notifications.every(n => n.checked);
  }


  formatAge(age: string) {
    const currentDate = new Date();
    const ageDate = new Date(age);

    if (age.includes("hour") || age.includes("minute")) {
      return age; 
    }
    const timeDiff = Math.abs(currentDate.getTime() - ageDate.getTime());

    const diffInHours = Math.floor(timeDiff / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInHours < 24) {
      return `${diffInHours} hours ago`;
    } else {
      const formattedDays = diffInDays.toLocaleString();
      return `${formattedDays} days ago`;
    }
  }

  onSubmit() {
  }

  export() {
  }
}
